import React, { useCallback, useContext } from 'react';
import moment from 'moment';
import styled from 'styled-components';
import { CircleIcon, FlexColumn, PromptClick } from '@ubeya/shared-web/components';
import { ReactComponent as CloseIcon } from '@ubeya/shared-web/assets/close-big.svg';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';

const Container = styled.div`
  margin: 6px;
`;

const Hour = styled.div`
  margin-right: 10px;
  font-size: 13px;
  flex: 1;
`;

const Content = styled(FlexColumn)`
  padding: 8px 10px;
  align-items: left;
  justify-content: center;
  border: 1px solid ${({ status, theme }) => (status === 0 ? theme.colors.greenPositive : theme.colors.redNegative)};
  border-radius: 4px;
  width: 210px;
  position: relative;
`;

const CloseButton = styled(CircleIcon)`
  height: 28px;
  width: 28px;
  position: absolute;
  right: 0;
  margin-left: 10px;
`;

export const TimeAvailabilityItemChip = ({ id, startTime, endTime, status, onDeletePeriod }) => {
  const onClick = useCallback(() => onDeletePeriod({ id, type: 'availability' }), [id, onDeletePeriod]);
  const { timeFormat } = useContext(ConfigContext);
  const { t } = useContext(ConfigContext);

  return (
    <Container>
      <Content status={status}>
        <Hour>
          {`${moment(startTime).format(timeFormat)}-${moment(endTime).format(timeFormat)}`}{' '}
          {t(status === 1 ? 'weeklyPreferenceNotPrefer' : 'weeklyPreferencePrefer')}
        </Hour>
        <PromptClick onClick={onClick} body="areYouSureYouWantToDeleteAvailability" confirmText="yes" usePortal>
          <CloseButton icon={CloseIcon} />
        </PromptClick>
      </Content>
    </Container>
  );
};
